import { PrizmLanguageCron } from '../../interfaces';

export const PRIZM_RUSSIAN_CRON: PrizmLanguageCron = {
  cron: {
    title: 'Крон',
    submitText: 'Применить',
    resetText: 'Отменить',
    startDateLabel: 'Начало работы',
    endDateLabel: 'Конец работы',
    chooseYearLabel: 'Введите год',
    indefinitelyLabel: 'Бессрочно',
    switcherTitles: {
      second: 'Секунды',
      minute: 'Минуты',
      hour: 'Часы',
      day: 'Дни',
      month: 'Месяцы',
      year: 'Годы',
    },

    every: 'Каждый',
    to: 'до',
    at: 'В',

    second: 'секунда',
    secondSince: 'секунда, начиная с',
    selectedSecond: 'Выбранная секунда (выбор одной или нескольких)',
    everySecond: 'Каждая секунда',
    everySecondFrom: 'Каждая секунда с',

    minute: 'минута',
    minuteSince: 'минута, начиная с',
    selectedMinute: 'Выбранная минута (выбор одной или нескольких)',
    everyMinute: 'Каждая минута',
    everyMinuteFrom: 'Каждая минута с',

    hour: 'час',
    hourSince: 'час, начиная с',
    selectedHour: 'Выбранный час (выбор одного или нескольких)',
    everyHour: 'Каждый час',
    everyHourFrom: 'Каждый час с',

    day: 'день',
    everyDay: 'Каждый день',
    daySince: 'день, начиная с',
    dayOfMonth: 'числа месяца',
    ofMonth: 'месяца',

    specificWeekDays: 'По определённым дням недели (выбор одного или нескольких)',
    specificMonthDays: 'По определённым дням месяца (выбор одного или нескольких)',

    last_dayOfMonth: 'Последний день месяца',
    last_workingDayOfMonth: 'Последний рабочий день месяца',
    last_dayOfWeek: 'В последний (-юю, -ее)',
    last_ofMonth: 'месяца',
    last_day: 'В последний (-ие)',
    untilEndOfMonth: 'день (дня, дней) до конца месяца',

    nearestWorkingDay: 'Ближайший рабочий день (Понедельник - Пятница) к',
    nearestToDayOfMonth: 'числу месяца',

    month: 'месяц',
    monthSince: 'месяц, начиная с',
    selectedMonth: 'Выбранный месяц (выбор одного или нескольких)',
    everyMonth: 'Каждый месяц',
    everyMonthFrom: 'Каждый месяц с',

    year: 'год',
    yearSince: 'год, начиная с',
    selectedYear: 'Выбранный год (выбор одного или нескольких)',
    everyYear: 'Каждый год',
    everyYearFrom: 'Каждый год с',

    weekDays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    shortWeekDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  },
};
